import { render, staticRenderFns } from "./upgrade__list.vue?vue&type=template&id=60eaa5ee"
import script from "./upgrade__list.vue?vue&type=script&lang=ts"
export * from "./upgrade__list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports